/**
 * Copied from https://github.com/angular/material.angular.io/blob/master/src/app/shared/style-manager/style-manager.ts
 * TODO(@SiddAjmera): Give proper attribution here
 */

import { Injectable } from "@angular/core";
import _ from "lodash";

export interface Theme {
  backgroundColor: string;
  buttonColor: string;
  headingColor: string;
  label: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})
export class StyleManagerService {
  private readonly localStorageKey = 'selectedTheme';
  public readonly themes: Array<Theme> = [
    {
      backgroundColor: "#303030",
      buttonColor: "#455a63",
      headingColor: "#307d38",
      label: 'Dev. Green',
      value: 'dimandzhi'
    },
    {
      backgroundColor: "#fafafa",
      buttonColor: "#f3453c",
      headingColor: "#3f51b1",
      label: 'Indigo & Pink',
      value: 'indigo-pink'
    },
    {
      backgroundColor: "#fafafa",
      buttonColor: "#f3453c",
      headingColor: "#673bb3",
      label: 'Deep Purple & Amber',
      value: 'deeppurple-amber'
    }
  ];

  constructor() {
    let themeToSet = localStorage.getItem(this.localStorageKey);
    if (_.isString(themeToSet) && !_.isUndefined(_.find(this.themes, {value:themeToSet}))) {
      this.setTheme(themeToSet);
    } else {
      this.setTheme(this.themes[0].value);
    }
  }

  setTheme(themeToSet: string) {
    this.setStyle(
      "theme",
      //`node_modules/@angular/material/prebuilt-themes/${themeToSet}.css`
      `${themeToSet}.css`
    );
    localStorage.setItem(this.localStorageKey, themeToSet);
  }

  /**
   * Set the stylesheet with the specified key.
   */
  setStyle(key: string, href: string) {
    getLinkElementForKey(key).setAttribute("href", href);
  }

  /**
   * Remove the stylesheet with the specified key.
   */
  removeStyle(key: string) {
    const existingLinkElement = getExistingLinkElementByKey(key);
    if (existingLinkElement) {
      document.head.removeChild(existingLinkElement);
    }
  }
}

function getLinkElementForKey(key: string) {
  return getExistingLinkElementByKey(key) || createLinkElementWithKey(key);
}

function getExistingLinkElementByKey(key: string) {
  return document.head.querySelector(
    `link[rel="stylesheet"].${getClassNameForKey(key)}`
  );
}

function createLinkElementWithKey(key: string) {
  const linkEl = document.createElement("link");
  linkEl.setAttribute("rel", "stylesheet");
  linkEl.classList.add(getClassNameForKey(key));
  document.head.appendChild(linkEl);
  return linkEl;
}

function getClassNameForKey(key: string) {
  return `app-${key}`;
}
